import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

interface DownloadGraphPromptProps {
  handleDownloadGraph: () => void;
}

const DownloadGraphPrompt: React.FC<DownloadGraphPromptProps> = (props) => {
  return (
    <Box>
      <Tooltip
        title={i18n._(
          msg({
            context:
              "Title of a button which allows the user to download the generated graph response.",
            message: "Download",
          }),
        )}
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "0.9rem",
            },
          },
        }}
      >
        <IconButton onClick={props.handleDownloadGraph} size="small">
          <FileDownloadOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default DownloadGraphPrompt;
